import { useCallback, useEffect, useState } from "react";

import { useFormContext } from "@ui/components/Form";
import { useTranslations } from "@ui/providers/useTranslations";

import { useConfig } from "@jti/app-context/useConfig";
import { getPassVerifiedData, PASS_VERIFIED_DATE_OF_BIRTH_COOKIE } from "@jti/fe-common";

export type UseDateOfBirthFromAv = (dobPrefix?: string) => {
  isDobAutopopulated: boolean;
};

const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD format From PASS AV

export const useDateOfBirthFromAv: UseDateOfBirthFromAv = (dobPrefix = "dob") => {
  const [isValid, setIsValid] = useState(false);
  const { __ } = useTranslations();
  const { setValue } = useFormContext();
  const config = useConfig();

  const handleSetDateOfBirth = useCallback(() => {
    const passVerifiedDateOfBirth = getPassVerifiedData(PASS_VERIFIED_DATE_OF_BIRTH_COOKIE);
    if (
      !!passVerifiedDateOfBirth &&
      typeof passVerifiedDateOfBirth === "string" &&
      dateRegex.test(passVerifiedDateOfBirth)
    ) {
      const dobDay = `${dobPrefix}.dobDay`;
      const dobMonth = `${dobPrefix}.dobMonth`;
      const dobYear = `${dobPrefix}.dobYear`;
      const dateOfBirth = new Date(passVerifiedDateOfBirth);
      const day = dateOfBirth.getDate().toString().padStart(2, "0");
      const month = (dateOfBirth.getMonth() + 1).toString().padStart(2, "0");
      const year = dateOfBirth.getFullYear().toString();

      const isDobInInputMode = config.dobFormType === "inputs" || config.dobFormType === "inputs_reversed";

      setValue(dobDay, isDobInInputMode ? day : { value: day, label: day });
      setValue(
        dobMonth,
        isDobInInputMode
          ? month
          : {
              value: month,
              label: __(`month.${month}`),
            }
      );
      setValue(dobYear, isDobInInputMode ? year : { value: year, label: year });

      setIsValid(true);
    }
  }, [dobPrefix, setValue, __, config.dobFormType]);

  useEffect(() => {
    handleSetDateOfBirth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isDobAutopopulated: isValid,
  };
};
